module.exports = __webpack_public_path__ + "static/media/security-check_1.9864acac.png";